class Menu {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.classOpen = 'menu--is-open'
    }
    run() {
        const open = document.getElementById('open')
		const close = document.getElementById('none')
		const bg = document.getElementById('bg')

		open.addEventListener('click', function onClick() {
			bg.style.opacity = '1'
			bg.style.display = 'block'
		})

		close.addEventListener('click', function onClick() {
			bg.style.opacity = '0'
			bg.style.display = 'none'
		})
        document.querySelectorAll('[data-menu]').forEach((el) => this.init(el))
    }
    init(elMenu) {
        const elID = elMenu.dataset.menu;
        document.querySelectorAll('[data-menu-toggle="' + elID + '"]').forEach((el) => this.initAction(el, elMenu, 'toggle'))
        document.querySelectorAll('[data-menu-open="' + elID + '"]').forEach((el) => this.initAction(el, elMenu, 'open'))
        document.querySelectorAll('[data-menu-close="' + elID + '"]').forEach((el) => this.initAction(el, elMenu, 'close'))
    }
    initAction(elAction, elMenu, actionType) {
        elAction.addEventListener('click', () => {
            if ('open' === actionType) {
                elMenu.classList.add(this.classOpen)
            } else if ('close' === actionType) {
                elMenu.classList.remove(this.classOpen)
            } else {
                elMenu.classList.toggle(this.classOpen)
            }
        })
    }
}

export default Menu